import { render, staticRenderFns } from "./go-back.vue?vue&type=template&id=04cb9932&scoped=true"
import script from "./go-back.vue?vue&type=script&lang=js"
export * from "./go-back.vue?vue&type=script&lang=js"
import style0 from "./go-back.vue?vue&type=style&index=0&id=04cb9932&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cb9932",
  null
  
)

export default component.exports